import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './NewStoryCard.scss';
import IconWrapper from './IconWrapper';
import RatingComponent from './RatingComponent';

function StoryContent({
  cardType,
  iconClass,
  videoTime,
  cmstype,
  title,
  subTitle,
  addTitleAsHeading,
  movieCardData,
  syn,
  synStyle,
  createdTime2,
  createdTime,
  sectionName,
  topCatText,
  sectionNameTop,
  inlineCard,
  wrapAroundIcon = true,
  criticRating,
  userRating,
  userCount,
  onCriticRatingClick,
  onUserRatingClick,
  useSynopsisLink,
  buttonText,
  headingImageSrc,
  birthdate,
  hobbies,
}) {
  const TitleTag = addTitleAsHeading ? 'h3' : 'div';
  const checkHtml = /(<([^>]+)>)/i;
  const htmlStatus = title ? checkHtml.test(title) : '';
  const ignoremovielink = cardType === 'card_29';

  return (
    <div className={`${s.scContentWrap} bg_color`}>
      {topCatText && <div className={s.topCatText}>{topCatText}</div>}
      {/* Title */}
      {htmlStatus ? (
        <TitleTag
          className={`${s.cardHeading} style_change ${
            wrapAroundIcon && !sectionNameTop ? s.wrapAroundIcon : ''
          }`}
          dangerouslySetInnerHTML={{
            __html: (
              <>
                <IconWrapper
                  iconClass={iconClass}
                  sectionNameTop={sectionNameTop}
                  inlineCard={inlineCard}
                  cardType={cardType}
                  videoTime={videoTime}
                  cmstype={cmstype}
                />
                {title}
              </>
            ),
          }}
        />
      ) : (
        <TitleTag
          className={`${s.cardHeading} style_change ${
            wrapAroundIcon && !sectionNameTop ? s.wrapAroundIcon : ''
          }`}
        >
          <IconWrapper
            iconClass={iconClass}
            sectionNameTop={sectionNameTop}
            inlineCard={inlineCard}
            cardType={cardType}
            videoTime={videoTime}
            cmstype={cmstype}
          />
          {headingImageSrc && (
            <div className={s.headingImage}>
              <img src={headingImageSrc} alt={title} />
            </div>
          )}
          {title}
        </TitleTag>
      )}

      {/* Subtitle */}
      {subTitle && <p className={s.cardText}>{subTitle}</p>}

      {/* Movie Card Data */}
      {movieCardData && (
        <div className={s.geners}>
          {ignoremovielink
            ? Object.values(movieCardData)
                .filter(value => value && (value.label || value.component))
                .map(value => (value.component ? value.component : value.label))
                .join(' | ')
            : Object.values(movieCardData).map((value, moviePropertyIndex) => {
                if (!(value && (value.label || value.component))) return null;

                if (value.link) {
                  return (
                    <span key={moviePropertyIndex}>
                      <Link to={value.link}>{value.label}</Link>
                    </span>
                  );
                }

                if (value.component) {
                  return (
                    <span key={moviePropertyIndex}>{value.component}</span>
                  );
                }

                return <span key={moviePropertyIndex}>{value.label}</span>;
              })}
        </div>
      )}

      {/* Created Time 2 */}
      {createdTime2 && <p className={s.createdTime}>{createdTime2}</p>}

      <RatingComponent
        cardType={cardType}
        criticRating={criticRating}
        userRating={userRating}
        userCount={userCount}
        onCriticRatingClick={onCriticRatingClick}
        onUserRatingClick={onUserRatingClick}
      />
      {birthdate && (
        <span className={s.calendarDate}>
          <i className={s.calendarIcon} /> {birthdate}
        </span>
      )}

      {syn && (
        <p className={s.cardText} style={synStyle}>
          {useSynopsisLink ? (
            <>
              {`${syn.slice(0, 150)}...`}{' '}
              <Link to={useSynopsisLink} className={s.link}>
                Read Full Review <i className={s.arrowRight} />
              </Link>
            </>
          ) : (
            syn
          )}
        </p>
      )}

      {hobbies && <span className={s.redText}>{hobbies}</span>}

      {/* Section Name */}
      {sectionName && <div className={s.catText}>{sectionName}</div>}

      {/* Created Time */}
      {createdTime && <span className={s.createdTime}> {createdTime}</span>}

      {/* {For Link } */}
      {buttonText && <div className={s.buttonText}> {buttonText} </div>}
    </div>
  );
}

StoryContent.propTypes = {
  cardType: PropTypes.string,
  iconClass: PropTypes.string,
  videoTime: PropTypes.string,
  cmstype: PropTypes.string,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  addTitleAsHeading: PropTypes.bool,
  syn: PropTypes.string,
  createdTime2: PropTypes.string,
  createdTime: PropTypes.string,
  sectionName: PropTypes.string,
  buttonText: PropTypes.string,
  criticRating: PropTypes.string,
  userRating: PropTypes.string,
  userCount: PropTypes.string,
  sectionNameTop: PropTypes.string,
  topCatText: PropTypes.string,
  inlineCard: PropTypes.bool,
  wrapAroundIcon: PropTypes.bool,
  useSynopsisLink: PropTypes.bool,
  onCriticRatingClick: PropTypes.func,
  onUserRatingClick: PropTypes.func,
  headingImageSrc: PropTypes.string,
  birthdate: PropTypes.string,
  hobbies: PropTypes.string,
};

StoryContent.defaultProps = {
  cardType: '',
  iconClass: '',
  videoTime: '',
  cmstype: '',
  subTitle: '',
  addTitleAsHeading: false,
  syn: '',
  createdTime2: '',
  createdTime: '',
  sectionName: '',
  topCatText: '',
  buttonText: '',
  criticRating: '',
  userRating: '',
  userCount: '',
  sectionNameTop: '',
  inlineCard: false,
  wrapAroundIcon: true,
  useSynopsisLink: false,
  headingImageSrc: '',
  onCriticRatingClick: () => {},
  onUserRatingClick: () => {},
  birthdate: '',
  hobbies: '',
};

export default StoryContent;
